/**
 * Geocode status chip (tracker item 41): Found, Approximate, Pending, Not
 * found, Failed, Set by hand, Off. Used on the property Location panel and in
 * Settings.
 */

import React from 'react';
import * as types from '../api/types';

const TONES = {
  green: 'bg-green-50 text-green-700 ring-green-200',
  amber: 'bg-amber-50 text-amber-800 ring-amber-200',
  red: 'bg-red-50 text-red-700 ring-red-200',
  blue: 'bg-blue-50 text-blue-700 ring-blue-200',
  gray: 'bg-gray-100 text-gray-700 ring-gray-200',
} as const;

/** The chip's words for a status (and precision: a postcode match is "Approximate"). */
export function geocodeStatusLabel(status: types.GeocodeStatus, precision?: types.GeocodePrecision | null): string {
  switch (status) {
    case 'OK':
      return precision === 'POSTCODE' ? 'Approximate' : 'Found';
    case 'PENDING':
      return 'Pending';
    case 'NOT_FOUND':
      return 'Not found';
    case 'FAILED':
      return 'Failed';
    case 'MANUAL':
      return 'Set by hand';
    case 'SKIPPED':
      return 'Geocoding off';
  }
}

function toneOf(status: types.GeocodeStatus, precision?: types.GeocodePrecision | null): keyof typeof TONES {
  if (status === 'OK') return precision === 'POSTCODE' ? 'amber' : 'green';
  if (status === 'MANUAL') return 'blue';
  if (status === 'NOT_FOUND' || status === 'FAILED') return 'red';
  return 'gray';
}

export function GeocodeStatusChip({ status, precision }: { status: types.GeocodeStatus; precision?: types.GeocodePrecision | null }) {
  return (
    <span
      data-testid="geocode-status"
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ring-1 ring-inset ${TONES[toneOf(status, precision)]}`}
    >
      {geocodeStatusLabel(status, precision)}
    </span>
  );
}
